import { Block, BreakerPanel, BreakerPanelType } from '@bechtel/sr-types';

export interface BreakerModelProps {
  visible: boolean;
  close: () => void;
  onBreakersUpdated: (breakerPanels: BreakerPanel[]) => void;
  panelType: BreakerPanelType;
  block: Block;
  canEdit: boolean;
  commodityId: string;
}

export const panelInitialWidth = 530;
export const descriptionColumnWidth = 120;

export type PanelItem = Omit<BreakerPanel, '__typename'> & {
  rowSpan: number;
  pointTag?: string | null;
  breakerSizeAmps?: number | null;
  breakerRev?: string | null;
  connectedLoad?: number | null;
};
